(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-additions-components/assets/javascripts/sportkryss.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-additions-components/assets/javascripts/sportkryss.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const format = svs.utils.format;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  RadioButton = _svs$ui$reactForm.RadioButton,
  Fieldset = _svs$ui$reactForm.Fieldset,
  Form = _svs$ui$reactForm.Form;
const actions = svs.components.tipsen.engine.actions;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.engineSelectors,
  selectSportkryssFactors = _svs$components$tipse.selectSportkryssFactors,
  selectSportkryssBase = _svs$components$tipse.selectSportkryssBase;
const selectCurrentSportkryssFactor = svs.components.tipsen.engine.selectors.couponSelectors.selectCurrentSportkryssFactor;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const BaseAddons = svs.components.tipsen.baseAddons.BaseAddons;
const SportkryssNumberArea = svs.components.tipsen.couponAdditionsComponents.sportkryss.SportkryssNumberArea;
const Sportkryss = () => {
  const couponId = useCouponId();
  const currentSportkryssFactor = useSelector(state => selectCurrentSportkryssFactor(state, couponId));
  const sportkryssFactors = useSelector(selectSportkryssFactors);
  const sportKryssBase = useSelector(selectSportkryssBase);
  const dispatch = useDispatch();
  const sportkryssCount = sportkryssFactor => {
    if (sportkryssFactor === 0) {
      return 'Nej';
    }
    return "".concat(format.Currency(sportkryssFactor * sportKryssBase), " kr");
  };
  return React.createElement(BaseAddons, {
    description: "Ett till\xE4ggsspel med dragning p\xE5 l\xF6rdagar. En insats p\xE5 10, 20 och 30 kr ger en m\xF6jlig vinst p\xE5 10, 20 och 30 miljoner!",
    icon: "games",
    id: "sportkryss",
    title: "Sportkryss"
  }, React.createElement(Form, {
    className: "tipsen-addition-form"
  }, React.createElement(Fieldset, {
    className: "sportkryss-fieldset-grid"
  }, React.createElement("legend", {
    className: "sr-only"
  }, "Vill du spela p\xE5 Sportkryss?"), React.createElement(ControlGroup, null, React.createElement(RadioGroup, {
    size: "200"
  }, sportkryssFactors.map((sportkryssFactor, index) => {
    const checked = currentSportkryssFactor === sportkryssFactor;
    return React.createElement(RadioButton, {
      "aria-checked": checked,
      checked: checked,
      className: checked ? 'f-bold' : '',
      key: sportkryssFactor,
      onChange: () => dispatch(actions.setSportkryssFactorIndex({
        couponId,
        sportkryssFactorIndex: index
      })),
      tabIndex: checked ? 0 : -1,
      value: sportkryssFactor
    }, sportkryssCount(sportkryssFactor));
  }))), React.createElement(SportkryssNumberArea, null))));
};
setGlobal('svs.components.tipsen.couponAdditionsComponents.Sportkryss', Sportkryss);

 })(window);